<template>
	<!-- 特俗样式表格 -->
	<div class="infobody_body">

		<div class="table_head">
			<div class="specliLeft" v-if="check">
				<span></span>
				<p></p>
			</div>
			<div class="head_evenly" v-for="(item,index) in tabList" :key="index">
				<span>{{item}}</span>
				<p></p>
			</div>
		</div>
		<div class="table_list" v-if="tableList.length" v-for="(items,index) in tableList" :key="index">
			<!-- <p>无数据</p> -->
			<div style="width: 70px;line-height: 50px;" v-if="check">
				<p><input type="checkbox" v-model="checked[index]" @click="sendCheckbox(index)"></input></p>
			</div>
			<div class="innerTable" v-for="(item,key) in items" :key="key">
				<p v-if="String(typeof item) !== 'object'">{{item}}</p>
				<p v-else v-for="(list,key) in item" :key="key" @click="showCopol(items,list,index)">{{list}}</p>
			</div>
		</div>
		<div class="table_list" style="justify-content: center;" v-if="!tableList.length">
			<p style="line-height: 50px;">暂无数据</p>
		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				checked: []
			}
		},
		props: {
			tabList: {
				type: Array,
				default: () => {
					return []
				}
			},
			tableList: {
				type: Array,
				default: () => {
					return []
				}
			},
			// 是否需要批量操作
			check: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			showCopol(item, list, key) {
				const params = {
					item: item,
					list: list,
					key: key
				}
				this.$emit('copol-click', params)
			},
			/* 复选框 */
			sendCheckbox(index) {
				// 特码的 大坑 checkebox异步绑定
				setTimeout(()=>{
					this.$emit('checkbox', this.checked)
				})
			}
		}
	}
</script>

<style scoped="scoped">
	/* 信心变更主题内容 */
	.infobody_body {
		width: 100%;
		min-height: 90px;
		height: auto;
		background-color: #f9f9f9;
	}

	.table_head {
		display: flex;
		height: 40px;
		line-height: 40px;
	}

	.head_evenly {
		flex: 1;
		display: flex;
	}

	.specliLeft {
		width: 70px;
		display: flex;
	}

	.head_evenly span {
		background-color: #dce0e6;
		font-weight: bold;
		font-size: 15px;
		width: calc(100% - 2px);
	}

	.specliLeft span {
		background-color: #dce0e6;
		font-weight: bold;
		font-size: 15px;
		width: calc(100% - 2px);
	}

	.head_evenly:last-child span {
		width: 100%;
	}

	.head_evenly:last-child p {
		display: none;
	}

	.table_list {
		width: 100%;
		min-height: 50px;
		line-height: 20px;
		display: flex;
		border-bottom: 1px solid #e9e9e9;
	}

	.innerTable {
		font-size: 14px;
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.btninner {
		cursor: pointer;
	}

	.innerTable:last-child {
		color: #4facfe;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		flex-wrap: wrap;
		align-content: space-evenly;
		cursor: pointer;
	}

	.innerTable:last-child p {
		line-height: 25px;
	}
</style>
